export default "__VITE_ASSET__Bsm37eY3__"